<!-- Registration context: full editable form -->
<div *ngIf="registrationContext">
  <div class="title-row">
    <div class="form-title">
      Add Details
    </div>
    <div class="required-text">* Required Field</div>
  </div>
  <form>
    <div>
      <div class="side-by-side-inputs">
        <ciao-form-field
          type="text"
          label="First Name"
          class="half-width-input"
          [formControlInput]="formGroup.get('person.firstName')"
        ></ciao-form-field>
        <ciao-form-field
          type="text"
          label="Last Name"
          class="half-width-input"
          [formControlInput]="formGroup.get('person.lastName')"
        ></ciao-form-field>
      </div>
    </div>
  </form>
</div>

<!-- Admin /users modal context: read-only info + editable admin roles -->
<div *ngIf="!registrationContext">
  <form>
    <h2 class="user-name-heading">
      {{ formGroup.get("person.firstName")?.value }}
      {{ formGroup.get("person.lastName")?.value }}
      <ciao-guest-badge
        [personId]="personId"
        variant="table"
      ></ciao-guest-badge>
    </h2>
    <div class="read-only-info">
      <div class="info-row" *ngIf="primaryEmail">
        <span class="info-label">Primary Email:</span>
        <span class="info-value">{{ primaryEmail }}</span>
      </div>
      <div class="info-row" *ngIf="secondaryEmail">
        <span class="info-label">Secondary Email:</span>
        <span class="info-value">{{ secondaryEmail }}</span>
      </div>
      <div class="info-row" *ngIf="supervisorDisplay">
        <span class="info-label">Supervisor:</span>
        <span class="info-value">{{ supervisorDisplay }}</span>
      </div>
    </div>

    <ciao-form-field
      class="full-width"
      label="Assign Admin Roles"
      placeholder="No Roles Selected"
      [type]="'multiselect'"
      width="100%"
      [formControlInput]="formGroup.get('regionRoles')"
      [selectOptions$]="AssignRegionRoleSelectOptions$"
      [compareWith]="AssignRegionRoleCompare"
      [customTrigger]="AssignRegionRoleCustomTriggerText"
    ></ciao-form-field>
  </form>
</div>
